import { useQuery } from '@apollo/client';

import { FeatureName } from '__generated__/GQL';
import useCanCompanyUserAccessFeature from 'common/hooks/useCanCompanyUserAccessFeature';

import { DetailedTransactionDocument } from './graphql/detailedTransaction.gql';

export const useDetailedTransactionQuery = (transactionId: string) => {
  const { canAccessFeature } = useCanCompanyUserAccessFeature();

  const { data, ...hook } = useQuery(DetailedTransactionDocument, {
    fetchPolicy: 'cache-and-network',
    variables: {
      canCancelTransfers: canAccessFeature({ name: FeatureName.Payments }),
      transactionId,
    },
  });

  return {
    transaction: data?.transaction,
    ...hook,
  };
};

export type DetailedTransaction = NonNullable<
  NonNullable<ReturnType<typeof useDetailedTransactionQuery>>['transaction']
>;

/**
 * @todo Remove "receipt" typing after multi doc release
 * @link https://linear.app/shine/issue/CAC-58
 */
export type DetailedTransactionReceipt =
  | NonNullable<
      NonNullable<
        NonNullable<
          ReturnType<typeof useDetailedTransactionQuery>
        >['transaction']
      >['receipt']
    >
  | NonNullable<
      NonNullable<
        NonNullable<
          ReturnType<typeof useDetailedTransactionQuery>
        >['transaction']
      >['receipts']
    >[number];
